/* ============================================================
 Oakland Sneakers brooklyn-quick-add.js
 Quick-add from product cards + PDP variant selection.
 Always adds the correct variant; opens the cart drawer on success.
 Depends on brooklyn-cart.js (updateCartUI, openCartDrawer, toast).
 ============================================================ */
(function () {
 'use strict';

 var ROUTES = (window.BrooklynConfig && window.BrooklynConfig.routes) || { cartAdd: '/cart/add.js' };

 /* ---------- Core add-to-cart ---------- */
 function addToCart(variantId, quantity) {
 return fetch(ROUTES.cartAdd, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
 }).then(function (res) {
 if (!res.ok) {
 return res.json().then(function (err) {
 throw new Error(err.description || 'Não foi possível adicionar.');
 });
 }
 return res.json();
 });
 }

 /* ---------- Quick-add (from product cards) ---------- */
 // Exposed globally because product-card.liquid uses inline onclick.
 window.quickAdd = function quickAdd(e, productId, variantId) {
 if (e) { e.preventDefault(); e.stopPropagation(); }
 if (!variantId) {
 // No variant resolved send shopper to the product page to pick a size.
 if (productId) showToast('Escolha o tamanho na página do produto.', true);
 return;
 }
 var btn = e && e.currentTarget;
 if (btn) { btn.disabled = true; btn.dataset._label = btn.textContent; btn.textContent = 'Adicionando…'; }

 addToCart(variantId, 1)
 .then(function () {
 if (typeof window.updateCartUI === 'function') window.updateCartUI();
 if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
 showToast('Adicionado ao carrinho!');
 })
 .catch(function (err) { showToast(err.message, true); })
 .finally(function () {
 if (btn) { btn.disabled = false; btn.textContent = btn.dataset._label || '+ Adicionar'; }
 });
 };

 /* ---------- PDP variant selection ---------- */
 // Sempre string: IDs de variante da Shopify são longos e não podem
 // sofrer arredondamento; e a comparação com dataset é feita como texto.
 var selectedVariantId = null;

 // Exposed globally; size-selector.liquid uses inline onclick.
 window.selectSize = function selectSize(variantId, size) {
 selectedVariantId = String(variantId);
 document.querySelectorAll('.bk-size__btn').forEach(function (btn) {
 var match = btn.dataset.variantId === selectedVariantId;
 btn.classList.toggle('selected', match);
 btn.setAttribute('aria-checked', match ? 'true' : 'false');
 });
 var wrap = document.querySelector('.bk-size');
 if (wrap) wrap.classList.remove('has-error');
 var errEl = document.querySelector('[data-size-error]');
 if (errEl) errEl.hidden = true;
 var addBtn = document.querySelector('.btn-add-cart');
 if (addBtn) addBtn.disabled = false;
 };

 function showSizeError() {
 var wrap = document.querySelector('.bk-size');
 if (wrap) {
 wrap.classList.add('has-error');
 wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
 }
 var errEl = document.querySelector('[data-size-error]');
 if (errEl) errEl.hidden = false;
 }

 function initPdp() {
 var addBtn = document.querySelector('.btn-add-cart');
 if (!addBtn) return;

 // Só pré-seleciona quando existe UMA única variante disponível.
 // Com vários tamanhos, o botão fica travado até o cliente escolher 
 // nunca assumir um tamanho por ele.
 var sizeBtns = document.querySelectorAll('.bk-size__btn');
 var available = [];
 sizeBtns.forEach(function (b) {
 if (b.dataset.available === 'true') available.push(b);
 });

 if (sizeBtns.length === 1 && available.length === 1) {
 window.selectSize(available[0].dataset.variantId, available[0].textContent.trim());
 } else {
 selectedVariantId = null;
 addBtn.disabled = true;
 }

 addBtn.addEventListener('click', function () {
 // Trava final: reconfere o tamanho lendo o botão realmente marcado na tela.
 // Só adiciona se a variante marcada bater com a guardada nunca chuta.
 var checked = document.querySelector('.bk-size__btn.selected');
 var domVariantId = checked ? checked.dataset.variantId : null;

 if (!selectedVariantId || !domVariantId || domVariantId !== selectedVariantId) {
 selectedVariantId = null;
 showSizeError();
 return;
 }

 var qtyInput = document.querySelector('[data-pdp-qty]');
 var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

 addBtn.disabled = true;
 var label = addBtn.textContent;
 addBtn.textContent = 'Adicionando…';

 addToCart(domVariantId, qty)
 .then(function () {
 if (typeof window.updateCartUI === 'function') window.updateCartUI();
 if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
 showToast('Adicionado ao carrinho!');
 })
 .catch(function (err) { showToast(err.message, true); })
 .finally(function () { addBtn.disabled = false; addBtn.textContent = label; });
 });
 }

 function showToast(msg, isError) {
 if (typeof window.brooklynToast === 'function') { window.brooklynToast(msg, isError); }
 else { console[isError ? 'warn' : 'log']('[Oakland]', msg); }
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', initPdp);
 } else {
 initPdp();
 }
})();
